import { useEffect, useState } from "react";

/**
 * 演示站点使用本地数据，这里用一个极短的模拟加载过程，
 * 让筛选、搜索、分页时的加载提示真实可见。
 */
export function useSimulatedLoading(key: string, delay = 320): boolean {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const timer = window.setTimeout(() => setLoading(false), delay);
    return () => window.clearTimeout(timer);
  }, [key, delay]);

  return loading;
}